import localizationEnUsHeader from "./en-us/header.json";
import localizationEnUsContent from "./en-us/content.json";

export const localizationEnUsStoreCheckoutComplete = {
  ...localizationEnUsHeader,
  ...localizationEnUsContent,
};
